<script lang="ts">
    import { onMount } from "svelte";
    import type { Game } from "../../model/Game";
    import type { IGamesController } from "../../controller";
    import { ConfigurationManager } from "../../ConfigurationManager";
    import { DefaultErrorHandler, getMessagingService, MESSAGE_TYPE } from "../../utility/ContextHelper.svelte";
    import { Slot, SLOT_TYPES } from "../../model/Slot";
    import SlotCreationCard from "../fragments/SlotCreationCard.svelte";
    import AddCard from "../components/AddCard.svelte";

    let { params = { id: undefined, copySlotId: undefined } } = $props();
    let game: Game = $state(undefined);
    let gmsCntrl: IGamesController = ConfigurationManager.getInstance().gamesController;

    let slot: Slot = $state(undefined)

    let isComplex: boolean = $derived(slot && slot.type === SLOT_TYPES.COMPLEX);


    onMount(() => {
        let copySlotId: string = params["copySlotId"];
        console.log("Copy " + copySlotId);

        // We want do duplicate the data of a slot
        if(copySlotId) {
            gmsCntrl.getSlot(copySlotId).then((incSlot: Slot) => {
                incSlot.id = undefined;
                if(incSlot.slots) {
                    for(let sub of incSlot.slots) {
                        sub.id = undefined;
                    }
                }
                slot = incSlot;
            }).catch(DefaultErrorHandler);
        }
        gmsCntrl.getGame(params["id"]).then((v: Game) => {
            game = v;

            if(!slot) {// do not overwrite the slot if a copyslot has been resolved
                slot = new Slot({
                    gameId: params["id"],
                    name: "",
                    dimensions: [1,1],
                    transparency: false,
                    type: SLOT_TYPES.TEXTURE,
                    slots: [],
                });                
            }
        }).catch(DefaultErrorHandler);
    });

    let msg = getMessagingService();

    let submitOngoing: boolean = $state(false);
    function submitForm() {
        submitOngoing = true;
        let gamesCntrl: IGamesController = ConfigurationManager.getInstance().gamesController;

        gamesCntrl.newSlot(slot).then((incomingSlot: Slot) => {
            msg.BoradcastMessage("Slot created successfully", MESSAGE_TYPE.SUCCESS);
            window.location.href = "#/game/" + game.id;
        }).catch(DefaultErrorHandler).finally(() => {
            submitOngoing = false;
        });
    }

    function deleteSubSlot(slotIndex: number) {
        const currentSlots: Slot[] = slot?.slots ?? [];
        const newSlots: Slot[] = currentSlots.filter((_, index) => index !== slotIndex);

        slot = new Slot({
           ...slot,
           slots: newSlots,
        });
    }

    function addSubslot() {
        if(!slot) {
            return;
        }

        const nextSubslots: Slot[] = [
            ...(slot.slots ?? []),
            new Slot({
                id: undefined,
                gameId: params["id"],
                name: "",
                dimensions: [1,1],
                transparency: false,
                type: SLOT_TYPES.TEXTURE,
            })
        ];

        slot = new Slot({
            ...slot,
            slots: nextSubslots,
        });
    }

</script>


{#if slot && game}
    <h1>Add a Slot for {game.name}</h1>
    {#if isComplex}
        <h2>Main Slot</h2>
    {/if}
    <div class="row">
        <div class="col-12 col-lg-3 px-2 mb-4">
            <SlotCreationCard bind:slot></SlotCreationCard>
        </div>
    </div>
    {#if isComplex}
        <h2>Sub Slots</h2>
        <div class="row">
            {#each slot.slots ?? [] as sub, index (sub)}
                <div class="col-12 col-lg-3 px-2 mb-4 position-relative">
                    <SlotCreationCard class="h-100" isSubSlot={true} bind:slot={slot.slots[index]}></SlotCreationCard>
                    <button class="btn btn-danger position-absolute end-0 top-0 me-2" onclick={() => deleteSubSlot(index)}>X</button>
                </div>
            {/each}
            <div class="col-12 col-lg-3 px-2 mb-4">
                <AddCard onclick={addSubslot}></AddCard>
            </div>
        </div>
    {/if}

    <button disabled={submitOngoing} class="btn btn-primary mt-4" onclick={submitForm}>Store</button>
{/if}
